import { useMemo } from 'react'
import { useTranslation } from '@paintscout/ui'
import type { EstimatorGroupLabels } from './buildEstimatorGroups'

/**
 * Translated labels for `buildEstimatorGroups`, shared by EstimatorSelect and the report UserFilter.
 * `fieldLabel` names the filtered field (e.g. "Project Manager") for the Unassigned sublabel.
 */
export function useEstimatorGroupLabels(fieldLabel?: string): EstimatorGroupLabels {
  const { __ } = useTranslation()
  return useMemo(
    () => ({
      active: __('Active'),
      selectAllActive: __('Select all active'),
      deactivated: __('Deactivated'),
      selectAllDeactivated: __('Select all deactivated'),
      unassigned: __('Unassigned'),
      unassignedSublabel: fieldLabel ? __('No %s', fieldLabel.toLocaleLowerCase()) : __('No estimator')
    }),
    [__, fieldLabel]
  )
}
